'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*----------------------------
Scripts
----------------------------*/

document.addEventListener('DOMContentLoaded', function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(event) {
    var nextPostContainer, articleId, blogArticlesUrl;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            nextPostContainer = document.querySelector('#next-article');

            if (!nextPostContainer) {
              _context.next = 6;
              break;
            }

            articleId = Number(nextPostContainer.dataset.articleId);

            // Fetch the articles

            blogArticlesUrl = '/blogs/the-truth?view=json';
            _context.next = 6;
            return fetch(blogArticlesUrl).then(function (response) {
              return response.json();
            }).then(function (articles) {
              var postCount = articles.length;
              var currentArticleIndex = articles.findIndex(function (elem) {
                return elem.id === articleId;
              });

              // Get the index of the next post.
              var nextPostIndex = void 0;

              if (currentArticleIndex === postCount - 1) {
                nextPostIndex = 0;
              } else {
                nextPostIndex = currentArticleIndex + 1;
              }

              // Get the next post.
              var nextPost = articles[nextPostIndex];

              // Insert into the dom.
              nextPostContainer.innerHTML = nextPost.text_card_markup;
            });

          case 6:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());